import { render } from "./JapanMapSVG.vue?vue&type=template&id=666a1746&scoped=true"
import script from "./JapanMapSVG.vue?vue&type=script&lang=js"
export * from "./JapanMapSVG.vue?vue&type=script&lang=js"

import "./JapanMapSVG.vue?vue&type=style&index=0&id=666a1746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666a1746"]])

export default __exports__